import React from "react";

import { Grid, Row, Col, Navbar, Nav, NavItem } from "react-bootstrap";
import ScrollContainer from "react-indiana-drag-scroll";
import { Modal, Divider, Button } from "antd";

import "./main.css";
import xrimatodotisi from "./xrimatodotisi.png";

import logo from "../assets/dotsoft_logo.png";

class IntroPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: true,
      title1: "Εργαλεία αναγνώρισης",
      text1:
        "Η απεικόνιση της πληροφορίας μπορεί να γίνει είτε μέσω ενός pop-up παραθύρου είτε μέσω ενός info window. Τα εργαλεία αναγνώρισης στο χάρτη μπορούν να συνδυάσουν πολυμεσικό περιεχόμενο, όπως προβολή εικόνων, sliders, βίντεο, παράθυρου 360ᵒ κ.α.",
      button1: "Είσοδος στην εφαρμογή",
      img1: "https://pogoni.gis4smart.city/img/01_pogoni_gis.png",
      alt1: "pc screen displaying map location form window",
      title2: "Εργαλεία χωρικής ανάλυσης",
      text2:
        "Ο χρήστης μέσω των εργαλείων χωρικής ανάλυσης και φιλτραρίσματος των δεδομένων, έχει την δυνατότητα θέτοντας τόσο χωρικά όσο και περιγραφικά κριτήρια να απαντήσει σε κάθε χωρικό ερώτημα, οπτικοποιώντας τα αποτελέσματα παράλληλα με την δυνατότητα λήψης των επιλεγμένων δεδομένων",
      button2: "Είσοδος στην εφαρμογή",
      img2: "https://pogoni.gis4smart.city/img/02_pogoni_gis.png",
      alt2: "laptop screen displaying a map with two markers in a location",
      title3: "Χαρτογραφικά υποβάθρα",
      text3:
        "Η πλατφόρμα υποστηρίζει την εναλλαγή χαρτογραφικών υποβάθρων. Συγκεκριμένα, υποστηρίζονται όλοι οι τύποι χαρτογραφικών υποβάθρων (basemaps), ενδεικτικά αναφέρονται: Google Maps, Bing Maps, MapBox Basemap, ESRI κ.α.",
      button3: "Είσοδος στην εφαρμογή",
      img3: "https://pogoni.gis4smart.city/img/03_pogoni_gis.png",
      alt3: "pc screen showing three different display options for maps",
      title4: "Εξαγωγή δεδομένων",
      text4:
        "Μέσω της εφαρμογής επιτρέπεται η λήψη των δεδομένων του χαρτογραφικού portal σε πολλαπλούς μορφότυπους δεδομένων. Ενδεικτικά η λήψη των δεδομένων της εφαρμογής μπορεί να γίνει στις ακόλουθες μορφές αρχείων: csv, kml, shpaefile, GeoJSON, GeoPackage κ.α.",
      button4: "Είσοδος στην εφαρμογή",
      img4: "https://pogoni.gis4smart.city/img/04_pogoni_gis.png",
      alt4: "People working together on devices.",
      title5: "Οργάνωση σε θεματικά επίπεδα",
      text5:
        "Η παρουσίαση των θεματικών επιπέδων του χάρτη μέσω layering, δίνει την δυνατότητα στον χρήστη να προσαρμόσει την σειρά με την οποία προβάλλονται τα δεδομένα στο περιβάλλον του χάρτη ώστε να πετύχει την βέλτιστη επιλογή οπτικοποίησης των δεδομένων ανάλογα με τις ανάγκες του",
      button5: "Είσοδος στην εφαρμογή",
      img5: "https://pogoni.gis4smart.city/img/05_pogoni_gis.png",
      alt5: "A computer screen with map.",
      activeTitle: "Εργαλεία αναγνώρισης",
      activeText:
        "Η απεικόνιση της πληροφορίας μπορεί να γίνει είτε μέσω ενός pop-up παραθύρου είτε μέσω ενός info window. Τα εργαλεία αναγνώρισης στο χάρτη μπορούν να συνδυάσουν πολυμεσικό περιεχόμενο, όπως προβολή εικόνων, sliders, βίντεο, παράθυρου 360ᵒ κ.α.",
      activeButton: "Είσοδος στην εφαρμογή",
      activeImage: "https://pogoni.gis4smart.city/img/01_pogoni_gis.png",
      activeAlt: "pc screen displaying map location form window",
      isModalOpen: false,
    };
  }

  showModal = () => {
    this.setState({
      ...this.state,
      isModalOpen: true,
    });
  };

  handleOk = () => {
    this.setState({
      ...this.state,
      isModalOpen: false,
    });
  };
  handleCancel = () => {
    this.setState({
      ...this.state,
      isModalOpen: false,
    });
  };

  toogleClass = (id) => {
    switch (id) {
      case 1:
        document.getElementById(1).className = "menu-tab-active";
        document.getElementById(2).className = "menu-tab";
        document.getElementById(3).className = "menu-tab";
        document.getElementById(4).className = "menu-tab";
        document.getElementById(5).className = "menu-tab";
        this.setState({
          activeTitle: this.state.title1,
          activeText: this.state.text1,
          activeButton: this.state.button1,
          activeImage: this.state.img1,
          activeAlt: this.state.alt1,
        });
        break;
      case 2:
        document.getElementById(1).className = "menu-tab";
        document.getElementById(2).className = "menu-tab-active";
        document.getElementById(3).className = "menu-tab";
        document.getElementById(4).className = "menu-tab";
        document.getElementById(5).className = "menu-tab";
        this.setState({
          activeTitle: this.state.title2,
          activeText: this.state.text2,
          activeButton: this.state.button2,
          activeImage: this.state.img2,
          activeAlt: this.state.alt2,
        });
        break;
      case 3:
        document.getElementById(1).className = "menu-tab";
        document.getElementById(2).className = "menu-tab";
        document.getElementById(3).className = "menu-tab-active";
        document.getElementById(4).className = "menu-tab";
        document.getElementById(5).className = "menu-tab";
        this.setState({
          activeTitle: this.state.title3,
          activeText: this.state.text3,
          activeButton: this.state.button3,
          activeImage: this.state.img3,
          activeAlt: this.state.alt3,
        });
        break;
      case 4:
        document.getElementById(1).className = "menu-tab";
        document.getElementById(2).className = "menu-tab";
        document.getElementById(3).className = "menu-tab";
        document.getElementById(4).className = "menu-tab-active";
        document.getElementById(5).className = "menu-tab";
        this.setState({
          activeTitle: this.state.title4,
          activeText: this.state.text4,
          activeButton: this.state.button4,
          activeImage: this.state.img4,
          activeAlt: this.state.alt4,
        });
        break;
      case 5:
        document.getElementById(1).className = "menu-tab";
        document.getElementById(2).className = "menu-tab";
        document.getElementById(3).className = "menu-tab";
        document.getElementById(4).className = "menu-tab";
        document.getElementById(5).className = "menu-tab-active";
        this.setState({
          activeTitle: this.state.title5,
          activeText: this.state.text5,
          activeButton: this.state.button5,
          activeImage: this.state.img5,
          activeAlt: this.state.alt5,
        });
        break;
      default:
    }
  };

  // dimoslamiasLink() {
  //     window.open("https://www.lamia.gr/", "_blank")
  // }

  // dotsoftLink() {
  //     window.open("https://www.dotsoft.gr/", "_blank")
  // }

  ypodomesLink = () => {
    window.open("http://40.74.15.111:8080/zitsa/#/viewer/19", "_blank");
  };

  perivallonLink = () => {
    window.open(
      "http://40.74.15.111:8080/zitsa/#/viewer/openlayers/23",
      "_blank",
    );
  };

  poleodomiaLink = () => {
    window.open("http://40.74.15.111:8080/zitsa/#/viewer/15", "_blank");
  };

  odofotismosLink = () => {
    window.open("http://40.74.15.111:8080/zitsa/#/viewer/31", "_blank");
  };

  gewtemachioLink = () => {
    window.open("http://40.74.15.111:8080/zitsa/#/viewer/27", "_blank");
  };

  dhmosLink = () => {
    window.open("https://www.zitsa.gov.gr/", "_blank");
  };

  // cityguide() {
  //     window.open("http://gis.lamia.gr/#/viewer/openlayers/123", "_blank")
  // }

  // urbanplanning() {
  //     window.open("http://gis.lamia.gr/#/viewer/openlayers/131", "_blank")
  // }

  render() {
    return (
      <Grid fluid={true}>
        <Row className="show-grid">
          <Col
            className="header_int"
            xs={12}
            md={12}
            style={{ margin: 0, padding: 0 }}
          >
            <Navbar inverse collapseOnSelect className="menu_cl">
              <div onClick={this.dhmosLink} className="logo_holder">
                <img
                  style={{ maxHeight: 56 + "px" }}
                  src="https://www.zitsa.gov.gr/img/layout/logo.png"
                  alt="munisipality_of_Zitsa_logo"
                />
              </div>
              <div className="container_intro">
                <div style={{ position: "absolute", left: -30 + "px" }}>
                  <img
                    src={"." + xrimatodotisi}
                    width={240 + "px"}
                    alt="xrimatodotisi"
                  />
                </div>
                <Navbar.Header>
                  <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                  <Nav pullRight>
                    <NavItem onClick={this.ypodomesLink} eventKey={1}>
                      Υποδομές
                    </NavItem>
                    <NavItem onClick={this.perivallonLink} eventKey={2}>
                      Περιβάλλον
                    </NavItem>
                    <NavItem onClick={this.poleodomiaLink} eventKey={3}>
                      Πολεοδομία
                    </NavItem>
                    <NavItem onClick={this.odofotismosLink} eventKey={4}>
                      Αναγγελία βλάβης Οδοφωτισμού
                    </NavItem>
                    <NavItem onClick={this.gewtemachioLink} eventKey={5}>
                      Βεβαίωση εντός/εκτός οικισμού
                    </NavItem>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </Col>
          <Col xs={12} md={12} style={{ margin: 0, padding: 0 }}>
            <div className="main_banner">
              <img
                src="https://www.serialhikers.com/wp-content/uploads/2017/08/DSC5183.jpg"
                alt="Landscape with the sun setting over grassy hills"
                width="100%"
                height="100%"
              />
              <div className="banner_holder">
                <div className="banner_text">
                  <h1 style={{ fontSize: "23px" }}>
                    ΚΑΛΩΣΗΡΘΑΤΕ ΣΤΗ ΓΕΩΠΥΛΗ ΤΟΥ ΔΗΜΟΥ ΖΙΤΣΑΣ
                  </h1>
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            align="center"
            style={{
              backgroundColor: "#757B0F",
              color: "#fff",
              borderBottom: "1px solid black",
              borderTop: "1px solid black",
              zIndex: 100,
            }}
          >
            <div className="text_after_banner">
              <h2
                align="left"
                className="welcome_text"
                style={{ marginBottom: 30 + "px" }}
              >
                Ο Δήμος σας καλωσορίζει στην ολοκληρωμένη Υποδομή Γεωχωρικών
                Πληροφοριών (Υ.Γε.Π.) - DotSpatial
              </h2>
              <p align="left">
                Μέσω της ιστοσελίδας αυτής, ο ενδιαφερόμενος θα βρει το σημείο
                εισόδου, έτσι, ώστε:
              </p>
              <ul style={{ textAlign: "left", marginLeft: 10 + "px" }}>
                <li>
                  Να αξιοποιήσει τις διαφορετικές εφαρμογές διάθεσης πληροφοριών
                </li>
                <li>
                  Να ανακαλύψει χρήσιμα δεδομένα πολεοδομικής και
                  περιβαλλοντικής φύσης, αλλά και να ενημερωθεί σχετικά με το
                  δίκτυο υποδομών του Δήμου
                </li>
                <li>
                  Η διάθεση των πληροφοριών πραγματοποιείται μέσω δικτυακών
                  υπηρεσιών θέασης, αναζήτησης και τηλεφόρτωσης των γεωχωρικών
                  δεδομένων βάσει ανοικτών προτύπων (OGC). Η διαδικασία
                  εμπλουτισμού, ανανέωσης και ολοκλήρωσης των δεδομένων
                  βρίσκεται σε συνεχή εξέλιξη.
                </li>
              </ul>
              <p align="left">
                Τα πλεονεκτήματα της εφαρμογής είναι πολλαπλά, ιδιαίτερα σε
                επαρχιακές περιοχές όπως ο Δήμος Ζίτσας και κύριοι στόχοι της
                λειτουργίας της Υποδομής αποτελούν η ελεύθερη πρόσβαση σε
                ανοικτά γεωαναφερμένα δεδομένα, η άρση του γεωγραφικού
                αποκλεισμού, η απλοποίηση διαδικασιών και η βελτιστοποίηση της
                εξυπηρέτησης του πολίτη αξιοποιώντας τις ψηφιακές τεχνολογίες.
              </p>
            </div>
          </Col>
          <Col xs={12} md={12} align="center">
            <h2 className="titleh2">
              Βασικές λειτουργικότητες της Υποδομής Γεωχωρικών Πληροφοριών -
              DotSpatial
            </h2>
            <ScrollContainer hideScrollbars="false" className="tabsCont">
              <div
                className="menu-tab-active"
                id="1"
                onClick={() => {
                  this.toogleClass(1);
                }}
              >
                <div>
                  <img
                    src="https://raw.githubusercontent.com/Esri/calcite-ui-icons/master/icons/applications-32.svg"
                    alt="line art of a globe"
                    width="64"
                    height="64"
                  />
                </div>
                <li style={{ listStyleType: "none", marginTop: 30 + "px" }}>
                  {this.state.title1}
                </li>
              </div>
              <div
                className="menu-tab"
                id="2"
                onClick={() => {
                  this.toogleClass(2);
                }}
              >
                <div>
                  <img
                    src="https://raw.githubusercontent.com/Esri/calcite-ui-icons/master/icons/analysis-32.svg"
                    alt="line art of a map"
                    width="64"
                    height="64"
                  />
                </div>
                <li style={{ listStyleType: "none", marginTop: 30 + "px" }}>
                  {this.state.title2}
                </li>
              </div>
              <div
                className="menu-tab"
                id="3"
                onClick={() => {
                  this.toogleClass(3);
                }}
              >
                <div>
                  <img
                    src="https://raw.githubusercontent.com/Esri/calcite-ui-icons/master/icons/basemap-32.svg"
                    alt="line art of four small boxes"
                    width="64"
                    height="64"
                  />
                </div>
                <li style={{ listStyleType: "none", marginTop: 30 + "px" }}>
                  {this.state.title3}
                </li>
              </div>
              <div
                className="menu-tab"
                id="4"
                onClick={() => {
                  this.toogleClass(4);
                }}
              >
                <div>
                  <img
                    src="https://raw.githubusercontent.com/Esri/calcite-ui-icons/master/icons/convert-32.svg"
                    alt="line art of a two papers"
                    width="64"
                    height="64"
                  />
                </div>
                <li style={{ listStyleType: "none", marginTop: 30 + "px" }}>
                  {this.state.title4}
                </li>
              </div>
              <div
                className="menu-tab"
                id="5"
                onClick={() => {
                  this.toogleClass(5);
                }}
              >
                <div>
                  <img
                    src="https://raw.githubusercontent.com/Esri/calcite-ui-icons/master/icons/arcgis-online-32.svg"
                    alt="line art of a cloud with three layers of paper"
                    width="64"
                    height="64"
                  />
                </div>
                <li style={{ listStyleType: "none", marginTop: 30 + "px" }}>
                  {this.state.title5}
                </li>
              </div>
            </ScrollContainer>
          </Col>
          <Col xs={12} md={12} align="center">
            <div className="flex_all_cont">
              <div className="flex_left_text">
                <div className="flex_left_text_parent">
                  <div className="inStyleR">
                    <h2 align="left" className="ef_title">
                      {this.state.activeTitle}
                    </h2>
                    <p
                      align="left"
                      style={{ marginBottom: 20 + "px", maxWidth: 550 + "px" }}
                    >
                      {this.state.activeText}
                    </p>
                    {/* <button onClick={this.gisLink} className="btn-default-new">
                                            {this.state.activeButton}<span style={{ marginLeft: 10 + 'px', position: 'absolute' }}><img src="https://raw.githubusercontent.com/Esri/calcite-ui-icons/master/icons/arrow-right-16.svg" width="17" /></span></button> */}
                  </div>
                </div>
              </div>
              <div className="flex_right_text">
                <div className="flex_right_text_parent">
                  <div>
                    <img
                      className="imageClass"
                      src={this.state.activeImage}
                      alt={this.state.activeAlt}
                    ></img>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col
            xs={12}
            md={12}
            // align="center"
            style={{
              borderTop: "1px solid #00000048",
              fontSize: "16px",
              margin: "0 auto",
            }}
          >
            <div
              style={{
                width: "80%",
                margin: "0 auto",
                textIndent: "20px",
                lineHeight: "28px",
              }}
            >
              <h2
                className="welcome_text"
                style={{ marginBottom: 30 + "px", textIndent: "0px" }}
              >
                Περιγραφή του έργου
              </h2>
              <p align="justify">
                Το έργο περιλαμβάνει εφαρμογές για τη διαχείριση απορριμμάτων,
                την παρακολούθηση των πηγών ρύπανσης της ατμόσφαιρας, την
                οργάνωση και διάθεση δεδομένων χρήσεων γης και χωροταξίας, την
                παρακολούθηση του συνόλου του στόλου των οχημάτων και τη
                διαχείριση του δικτύου πόσιμου ύδατος με χρήση «έξυπνων
                υδρομετρητών». Χάρη στο έργο ο Δήμος διαθέτει ένα ολοκληρωμένο
                σύστημα για:
              </p>

              <p>
                Α) τον έλεγχο της πληρότητας των κάδων που βρίσκονται τόσο σε
                απομακρυσμένες περιοχές, όσο και σε πολυσύχναστα σημεία όπως
                σχολεία, δημόσια κτίρια, ΚΑΠΗ, εκκλησίες, αγροτικά ιατρεία κτλ.
              </p>
              <p>
                Β) την αξιοποίηση νέων τεχνολογιών για την ενημέρωση και
                βελτίωση της καθημερινότητας του Δημότη.
              </p>
              <p>
                Γ) τη συνεχή παρακολούθηση των πηγών ρύπανσης της ατμόσφαιρας σε
                πραγματικό χρόνο μέσω δικτύου αισθητήρων ευέλικτων
                περιβαλλοντικών σταθμών.
              </p>
              <p>
                Δ) την δημιουργία υποδομής γεωχωρικών πληροφοριών του Δήμου, με
                την ενσωμάτωση σε αυτή των νέων δεδομένων. Έτσι ο Δήμος αποκτά
                κοινή επιχειρησιακή εικόνα για όλα τα δεδομένα με γεωχωρική
                υπόσταση.
              </p>
              <p>
                Ε) τον έλεγχο της κίνησης του συνόλου των απορριμματοφόρων, των
                οχημάτων πολιτικής προστασίας καθώς και των οχημάτων
                εργοταξιακών εργασιών, με επέκταση του υφιστάμενου συστήματος
                παρακολούθησης και διαχείρισης στόλου.
              </p>
              <p>
                ΣΤ) την αυτόματη καταγραφή της κατανάλωσης πόσιμου ύδατος, αλλά
                και εντοπισμού διαρροών με χρήση «έξυπνων υδρομέτρων».
              </p>

              <p align="left">
                Τα πλεονεκτήματα της εφαρμογής είναι πολλαπλά, ιδιαίτερα σε
                επαρχιακές περιοχές όπως ο Δήμος Ζίτσας και κύριοι στόχοι της
                λειτουργίας της Υποδομής αποτελούν η ελεύθερη πρόσβαση σε
                ανοικτά γεωαναφερμένα δεδομένα, η άρση του γεωγραφικού
                αποκλεισμού, η απλοποίηση διαδικασιών και η βελτιστοποίηση της
                εξυπηρέτησης του πολίτη αξιοποιώντας τις ψηφιακές τεχνολογίες.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <p align="center" style={{ textIndent: "0px" }}>
                  Το έργο εντάσσεται στο Επιχειρησιακό Πρόγραμμα “Ήπειρος
                  2014-2020” Με την συγχρηματοδότηση της Ελλάδας και της
                  Ευρωπαϊκής Ένωσης
                </p>
                <img
                  style={{ width: "250px", margin: "auto" }}
                  src={"." + xrimatodotisi}
                  // width={240 + "px"}
                  alt="xrimatodotisi"
                />
              </div>
            </div>
          </Col>

          <Col
            xs={12}
            md={12}
            align="center"
            style={{ borderTop: "1px solid rgba(0,0,0,0.5)" }}
          ></Col>

          <Col className="footerCl" xs={12} md={12}>
            <div
              style={{
                height: 30 + "px",
                display: "flex",
                alignItems: "center",
                float: "right",
              }}
            >
              <span style={{ display: "inline-block", marginRight: 5 + "px" }}>
                Powered by
              </span>
              <span
                style={{
                  marginRight: 10 + "px",
                  cursor: "pointer",
                  height: 18 + "px",
                }}
              >
                <a href="https://dotsoft.gr">
                  <img
                    src={logo}
                    width="80px"
                    alt="DOTSoft logo"
                  />
                </a>
              </span>
            </div>
            <div
              style={{
                height: 30 + "px",
                display: "flex",
                alignItems: "center",
                float: "left",
              }}
            >
              <span style={{ display: "inline-block", marginLeft: 10 + "px" }}>
                ©
              </span>
              <span
                style={{
                  fontStyle: "italic",
                  marginLeft: 10 + "px",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => {
                  this.showModal();
                }}
              >
                Δήλωση προσβασιμότητας
              </span>
            </div>
          </Col>
          <Modal
            width={800}
            title="Δήλωση προσβασιμότητας"
            open={this.state.isModalOpen}
            onOk={() => {
              this.handleOk();
            }}
            onCancel={() => {
              this.handleCancel();
            }}
            footer={[
              <Button key="back" type="primary" onClick={this.handleCancel}>
                OK
              </Button>,
            ]}
          >
            <Divider>Τμήμα 1</Divider>
            <h4 align="center" className="ef_title">
              ΔΗΛΩΣΗ ΠΡΟΣΒΑΣΙΜΟΤΗΤΑΣ
            </h4>
            <p
              align="left"
              style={{
                marginBottom: 20 + "px",
                textIndent: "20px",
                textAlign: "justify",
              }}
            >
              Ο ΔΗΜΟΣ ΖΙΤΣΑΣ δεσμεύεται να καθιστά τον οικείο ιστότοπο:
              zitsa.gis4smart.city προσβάσιμο, σύμφωνα με τις προβλέψεις του ν.
              4727/2020 (ΦΕΚ 184 Α’ 23-09-2020), Κεφάλαιο Η’ «ΨΗΦΙΑΚΗ
              ΠΡΟΣΒΑΣΙΜΟΤΗΤΑ (ΕΝΣΩΜΑΤΩΣΗ ΣΤΗΝ ΕΛΛΗΝΙΚΗ ΝΟΜΟΘΕΣΙΑ ΤΗΣ ΟΔΗΓΙΑΣ
              (ΕΕ) 2016/2102 ΤΟΥ ΕΥΡΩΠΑΪΚΟΥ ΚΟΙΝΟΒΟΥΛΙΟΥ ΚΑΙ ΤΟΥ ΣΥΜΒΟΥΛΙΟΥ, ΤΗΣ
              26ΗΣ ΟΚΤΩΒΡΙΟΥ 2016, ΓΙΑ ΤΗΝ ΠΡΟΣΒΑΣΙΜΟΤΗΤΑ ΤΩΝ ΙΣΤΟΤΟΠΩΝ ΚΑΙ ΤΩΝ
              ΕΦΑΡΜΟΓΩΝ ΓΙΑ ΦΟΡΗΤΕΣ ΣΥΣΚΕΥΕΣ ΤΩΝ ΟΡΓΑΝΙΣΜΩΝ ΤΟΥ ΔΗΜΟΣΙΟΥ ΤΟΜΕΑ)»
              που ενσωματώνει στην εθνική έννομη τάξη την Οδηγία (ΕΕ)
              2016/2012.Η παρούσα δήλωση προσβασιμότητας εφαρμόζεται στα εξής:
              στον ιστότοπο zitsa.gis4smart.city
            </p>
            <h4 align="center" className="ef_title">
              Κατάσταση συμμόρφωσης
            </h4>
            <p
              align="left"
              style={{
                marginBottom: 20 + "px",
                textIndent: "20px",
                textAlign: "justify",
              }}
            >
              Ο παρών ιστότοπος zitsa.gis4smart.city συνάδει πλήρως με τις
              Οδηγίες για την προσβασιμότητα στο περιεχόμενο Ιστού (WCAG 2.1
              ΑΑ).
            </p>
            <h4 align="center" className="ef_title">
              Κατάρτιση της παρούσας δήλωσης προσβασιμότητας
            </h4>
            <p
              align="left"
              style={{
                marginBottom: 20 + "px",
                textIndent: "20px",
                textAlign: "justify",
              }}
            >
              Η παρούσα δήλωση καταρτίστηκε την 21-11-2022.Η πραγματική
              αξιολόγηση της συμμόρφωσης του ιστοτόπου προς τις απαιτήσεις της
              Οδηγίας (ΕΕ) 2016/2102 πραγματοποιήθηκε με αυτοαξιολόγηση
              διενεργηθείσα από τον οργανισμό του δημόσιου τομέα και με την
              χρήση τουUserWay Website Accessibility Widget Τελευταία αναθεώρηση
              της δήλωσης στις 05-12-2022..
            </p>
            <h4 align="center" className="ef_title">
              Υποβολή παρατηρήσεων και στοιχεία επικοινωνίας
            </h4>
            <p
              align="left"
              style={{
                marginBottom: 20 + "px",
                textIndent: "20px",
                textAlign: "justify",
              }}
            >
              Σύμφωνα με τις προβλέψεις του ν. 4727/2020 (ΦΕΚ 184 Α’
              23-09-2020), άρθρο 45, κάθε ενδιαφερόμενος έχει δικαίωμα να
              υποβάλλει παρατηρήσεις ή αίτηση για ενημέρωση ως προς την
              κατάσταση συμμόρφωσης ή αίτηση για πληροφορίες που
              ελλείπουν.αίτηση για ενημέρωση ως προς την κατάσταση συμμόρφωσης ή
              αίτηση για πληροφορίες που ελλείπουν.Για θέματα προσβασιμότητας
              και για τη διεκπεραίωση αιτημάτων που υποβάλλονται μέσω του
              μηχανισμού υποβολής παρατηρήσεων υποβάλλονται στο e-mail:
              zitsa@zitsa.gov.gr:
            </p>

            <h4 align="center" className="ef_title">
              Διαδικασία εκτέλεσης
            </h4>
            <p
              align="left"
              style={{
                marginBottom: 20 + "px",
                textIndent: "20px",
                textAlign: "justify",
              }}
            >
              Η αρμόδια διεύθυνση του ΔΗΜΟΥ ΖΙΤΣΑΣ απαντά στον ενδιαφερόμενο με
              πρόσφορο τρόπο.Σε περίπτωσης μη ικανοποιητικής απάντησης στην
              ενημέρωση ή στα αιτήματα ο ενδιαφερόμενος δικαιούται να αποταθεί
              σύμφωνα με την πρόβλεψη στις αρμόδιες θεσμικές αρχές, όπως με την
              υποβολή σχετικής Αναφοράς στον Συνήγορο του Πολίτη
              (https://www.synigoros.gr).
            </p>

            <Divider>Τμήμα 2</Divider>
            <h4 align="center" className="ef_title">
              Ενεργοποίηση του Μενού Προσβασιμότητας
            </h4>
            <p
              align="left"
              style={{
                marginBottom: 20 + "px",
                textIndent: "20px",
                textAlign: "justify",
              }}
            >
              Το μενού προσβασιμότητας του ιστοτόπου zitsa.gis4smart.city μπορεί
              να ενεργοποιηθεί κάνοντας κλικ στο εικονίδιο του μενού
              προσβασιμότητας που εμφανίζεται στο πάνω μέρος της σελίδας. Αφού
              ενεργοποιήσετε το μενού προσβασιμότητας, περιμένετε λίγο για να
              φορτωθεί το μενού προσβασιμότητας στο σύνολό του. Το
              zitsa.gis4smart.city συνεχίζει τις προσπάθειές του για να
              βελτιώνει συνεχώς την προσβασιμότητα του ιστότοπου με την
              πεποίθηση ότι είναι η συλλογική ηθική μας υποχρέωση να επιτρέπουμε
              την απρόσκοπτη, προσβάσιμη και απρόσκοπτη χρήση και για όσους από
              εμάς έχουν αναπηρία. Σε μια συνεχή προσπάθεια για συνεχή βελτίωση
              και αποκατάσταση προβλημάτων προσβασιμότητας, σαρώνουμε τακτικά το
              zitsa.gis4smart.city με το σαρωτή προσβασιμότητας του UserWay για
              να εντοπίσουμε και να διορθώσουμε κάθε πιθανό εμπόδιο
              προσβασιμότητας στον ιστότοπο. Παρά τις προσπάθειές μας να κάνουμε
              όλες τις σελίδες και το περιεχόμενο στο zitsa.gis4smart.city
              πλήρως προσβάσιμο, κάποιο περιεχόμενο ενδέχεται να μην έχει ακόμη
              προσαρμοστεί πλήρως στα αυστηρότερα πρότυπα προσβασιμότητας.
            </p>
          </Modal>
        </Row>
      </Grid>
    );
  }
}

export default IntroPage;
